import { useState, useEffect } from "react";

import { Card, Flex, Typography, Space, Spin, App, Tree } from "antd";

import {
  FolderOutlined,
  FileOutlined,
  FileAddOutlined,
  DownOutlined,
} from "@ant-design/icons";

import CubIcon from "@/icons/CubIcon";

import CreateFolder from "./create-folder";
import ViewFolder from "./view-folder";
import ViewFile from "./view-file";

import { setDefinitionIntoMenu } from "@/api/definitionsMenu";

const { Title, Text } = Typography;

const Menu = ({ definition = {}, menu = [], pending, onChange }) => {
  const { message } = App.useApp();

  const [menuItems, setMenuItems] = useState([]);
  // const [switchMe, setSwitch] = useState(true);
  // const [showSettingPath, setShowSettingPath] = useState(false);
  const [path, setPath] = useState(null);

  useEffect(() => {
    const formateMenu = (menu) => {
      return menu.map(({ uuid, type, name, objects, folders }) => {
        let children = [];
        let listOptions = [];

        if (objects) listOptions = [...listOptions, ...objects];
        if (folders) listOptions = [...listOptions, ...folders];

        const hasItem = listOptions.some(
          (item) => item.child === definition.uuid
        );

        if (folders) {
          children = formateMenu(folders);
        }

        children.push({
          title: (
            <CreateFolder
              parent={type !== "main" ? uuid : null}
              onChangeFolder={() => onChange()}
            />
          ),
          key: `add-folder-to-${uuid}`,
        });

        if (objects) {
          objects.forEach((object) => {
            children.push({
              title: (
                <ViewFile
                  uuid={object.uuid}
                  name={object.name}
                  onChange={onChange}
                />
              ),
              key: object.uuid,
              icon: <FileOutlined />,
            });
          });
        }

        if (!hasItem) {
          children.push({
            title: (
              <Typography.Link
                style={{ paddingInline: "5px" }}
                onClick={() =>
                  handleSelectFolder(type !== "main" ? uuid : null)
                }
              >
                <Space>
                  <FileAddOutlined />
                  {definition.name}
                </Space>
              </Typography.Link>
            ),
            key: `add-leaf-to-${uuid}`,
          });
        }

        return {
          title:
            type === "folder" ? (
              <ViewFolder uuid={uuid} name={name} onChange={onChange} />
            ) : type === "object" ? (
              <ViewFile uuid={uuid} name={name} onChange={onChange} />
            ) : (
              name
            ),
          key: uuid,
          icon:
            type === "main" ? (
              <CubIcon
                style={{
                  color: "var(--color-secondary)",
                  fontSize: 16,
                  verticalAlign: "sub",
                }}
              />
            ) : type === "folder" ? (
              <FolderOutlined />
            ) : (
              <FileOutlined />
            ),

          ...(type !== "object" && { children: children }),
        };
      });
    };

    setMenuItems(
      formateMenu([
        {
          name: "Ресурсы",
          uuid: "main",
          type: "main",
          folders: menu,
        },
      ])
    );

    const findPath = (menu, id) => {
      let path = "";

      function search(items, currentPath) {
        for (const item of items) {
          if (item.child === id) {
            path = currentPath + item.name;
            return true;
          }

          if (
            item.objects &&
            search(item.objects, currentPath + item.name + " / ")
          ) {
            return true;
          }

          if (
            item.folders &&
            search(item.folders, currentPath + item.name + " / ")
          ) {
            return true;
          }
        }
        return false;
      }

      search(menu, "");

      return path;
    };

    setPath(findPath(menu, definition.uuid));
    // eslint-disable-next-line
  }, [menu]);

  const handleSelectFolder = async (parent) => {
    try {
      await setDefinitionIntoMenu({ parent, child: definition.uuid });
      onChange();
    } catch (error) {
      message.open({
        type: "error",
        content: error.message,
        duration: 10,
      });
    }
  };

  return (
    <Spin spinning={pending}>
      <Card
        title="Расположение в меню"
        // extra={
        //   <Space>
        //     <Switch value={switchMe} onChange={(value) => setSwitch(value)} />{" "}
        //     Показывать в меню
        //   </Space>
        // }
      >
        {/* {switchMe ? ( */}
        <Flex vertical gap={20}>
          <Flex gap={10} align="baseline" justify="space-between">
            <Flex gap={10} align="center" wrap>
              <Title level={5} className="no-margin">
                Текущий путь:
              </Title>
              {path ? (
                <>
                  <Flex align="center" wrap>
                    <Flex gap={4} align="center" style={{ marginRight: "4px" }}>
                      <CubIcon
                        style={{
                          color: "var(--color-secondary)",
                          fontSize: 16,
                        }}
                      />
                      Ресурсы
                    </Flex>
                    {` / ${path}`}
                  </Flex>
                </>
              ) : (
                <div className="text-secondary">-</div>
              )}
            </Flex>
            {/* <Link to="#" onClick={() => setShowSettingPath(true)}>
              <Space>
                <SettingOutlined />
                Настроить
              </Space>
            </Link> */}
          </Flex>

          <Text type="secondary">
            Ниже представлена структура меню. Вы можете добавлять новые папки и
            устанавливать текущее расположение. Для добавления новой папки
            нажмите на значок папки с плюсом. Для установки текущего
            расположения нажмите на соответствующий элемент в меню.
          </Text>

          <Tree
            defaultExpandedKeys={[definition.uuid]}
            selectable={false}
            showIcon
            showLine={true}
            switcherIcon={<DownOutlined />}
            treeData={menuItems}
          />
        </Flex>
        {/* ) : (
          `Представление в меню отключено и доступно только по прямой ссылке.`
        )} */}
      </Card>
    </Spin>
  );
};

export default Menu;
